import React from 'react';
import EagleViewLogoWithText from 'assets/EagleViewLogoWithText.svg';
import EagleViewLogo from 'assets/EagleViewLogo.svg';
import EagleViewLogoWithTextStacked from 'assets/EagleViewLogoWithTextStacked.svg';
import PropTypes from 'prop-types';
import { LOGO_TYPE } from 'constants/AppConstants';

function EVLogo(props) {
  const { type, ...rest } = props;

  let imgSrc;
  switch (type) {
    case LOGO_TYPE.LOGO_WITH_TEXT:
      imgSrc = EagleViewLogoWithText;
      break;
    case LOGO_TYPE.LOGO_WITH_TEXT_STACKED:
      imgSrc = EagleViewLogoWithTextStacked;
      break;
    default:
      imgSrc = EagleViewLogo;
  }

  return <img src={imgSrc} alt="EagleView Logo" {...rest} />;
}

EVLogo.propTypes = {
  type: PropTypes.oneOf(['logoWithText', 'logo', 'logoWithTextStacked']).isRequired,
};

export default EVLogo;
